const booleanReducer = (initialState, trueActions, falseActions) => (state = Boolean(initialState), action) => {
  if (trueActions.includes(action.type)) return true;
  if (falseActions.includes(action.type)) return false;
  return state;
};

export default booleanReducer;
